import { TOnlineBank } from './OpenBanking.types';
import { TGetContext, TOfferDataRequirement } from '../../../types';

type TRecommendedResolutionMethodItem = {
  external_id: string;
  online_account__bank: string;
  online_account__status_code: string;
};

export const getLinkedBankAccountDetails = (
  resolutionMethods: TOfferDataRequirement['actions'][number]['resolution_methods'],
  context: TGetContext['data'],
) => {
  const openBankingResolutionMethod = resolutionMethods.filter(
    (resolutionMethod) => {
      return resolutionMethod.type === 'link_bank_account_via_open_banking';
    },
  )[0];

  if (
    !openBankingResolutionMethod ||
    openBankingResolutionMethod.items.length < 1
  )
    return;

  // Currently multiple accounts can exist in one bank account with the same name. (e.g. Wise, Lloyds savings & chequing)
  // TODO: Change to return list of items when BE adds a new property that differentiates bank accounts.
  // e.g last_four_digits: 1234
  // @ts-expect-error typed as any[] in schema so not picked up by LAPI
  const trueLayerLinkedBankAccount: TRecommendedResolutionMethodItem =
    openBankingResolutionMethod.items[0];

  const trueLayerBanks: TOnlineBank[] | undefined =
    context.open_banking.truelayer_banks;

  if (!trueLayerBanks || !trueLayerLinkedBankAccount) return;

  const bankAccount = trueLayerBanks.filter((bank) => {
    return bank.bank_id === trueLayerLinkedBankAccount.online_account__bank;
  });

  return bankAccount[0];
};
